import type { ISerialize } from '@/objects/ISerialize';

export class SignalrGPIOReadingSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrGPIOReadingSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrGPIOReadingSubscribeParameters {
        return new SignalrGPIOReadingSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrGPIOReadingSubscribeParameters {
        return new SignalrGPIOReadingSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrGPIOReadingSubscribeParameters from another instance of SignalrGPIOReadingSubscribeParameters.
     * @param other The SignalrGPIOReadingSubscribeParameters you want to clone
     * @returns A cloned SignalrGPIOReadingSubscribeParameters
     */
    public static FromOther(other: SignalrGPIOReadingSubscribeParameters): SignalrGPIOReadingSubscribeParameters {
        return SignalrGPIOReadingSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrGPIOReadingSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrGPIOReadingSubscribeParameters';
}
